import { lazy, useContext } from 'react'
import { NVButton } from '@nv/basic-components'
import { OnboardProgressBar, useNVModal } from '@nv/components'
import { LoginFlowContext, useAdminUserContext, useVoterUserContext } from '@nv/contexts'
import { VoterOnboardingContext } from '@nv/contexts'
import InfoIcon from '@nv/images/design/info-icon'
import clsx from 'clsx'
import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate } from 'react-router-dom'
import styles from './AuthAppSetup.module.scss'
import '@djthoms/pretty-checkbox'
const AuthAppInfo = lazy(() => import('@nv/lazy-loadable/lib/modals/AuthAppInfo'))

export const AuthAppSetup = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const location = useLocation()
  const qrCodeDataUrl = location.state?.qrCodeDataUrl
  const factorSid = location?.state?.factorSid
  const { setAuthMethod } = useContext(VoterOnboardingContext)
  const VoterUser = useVoterUserContext().voterUser
  const { adminUser } = useAdminUserContext()
  const LOGIN_CONTEXT = useContext(LoginFlowContext)
  const isLoginFlow = LOGIN_CONTEXT.loginFlow !== 'Onboarding'
  const { NVModal, openModal } = useNVModal()

  const onClickNext = () => {
    setAuthMethod('Authapp')
    if (LOGIN_CONTEXT.loginFlow.startsWith('Admin')) navigate('/admin/auth/verify', { state: { factorSid } })
    else navigate('/voting/voter-verify/verify')
  }

  const onClickBack = () => navigate('/voting/voter-onboarding/auth-method')

  return (
    <div className={styles['container']}>
      <NVModal>
        <AuthAppInfo />
      </NVModal>

      <div className={clsx(styles['form'], isLoginFlow && styles['form--login'])}>
        {LOGIN_CONTEXT.loginFlow === 'Onboarding' && <OnboardProgressBar currentStep={2} />}
        <div className={styles['body']}>
          <div className={styles['header']}>
            <h2>{LOGIN_CONTEXT.loginFlow.startsWith('Admin') ? t('auth.yourUsername.admin') : t('auth.yourUsername.voter')}</h2>
            <h1>{VoterUser?.username || adminUser?.username}</h1>
          </div>

          {!LOGIN_CONTEXT.loginFlow.startsWith('Admin') && (
            <div className={styles['admin-header']}>
              <h2>{t('auth.authMethod.heading')}</h2>
              <InfoIcon className={styles['admin-header__info-icon']} onClick={() => openModal()} />
            </div>
          )}

          <div>{t('auth.authApp.instruction')}</div>

          <div className={styles['qr-code']}>
            <img alt='qrCode' className={styles['qr-code__img']} src={qrCodeDataUrl} />
            <span className={styles['qr-code__scan-me-label']}>{t('auth.qrCode.scanMe')}</span>
          </div>
        </div>
        <div className={styles['footer']}>
          {!LOGIN_CONTEXT.loginFlow.startsWith('Admin') && (
            <NVButton variant='secondary' text={t('buttons.back')} height={50} onClick={onClickBack} />
          )}

          <NVButton text={t('buttons.next')} height='50px' onClick={onClickNext} />
        </div>
      </div>
    </div>
  )
}
